import { useCallback } from 'react';
import { permitLettersService } from '../services';
import {
  useResourceCollection,
  useCreateResource,
  useUpdateResource,
  useDeleteResource,
  ResourceState,
  MutationState,
} from './useResource';
import { ResourceQueryOptions } from '../services/resources.service';
import { PermitLetter } from '../types';

export function usePermitLetters(
  options?: ResourceQueryOptions
): ResourceState<PermitLetter> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      permitLettersService.getAll(opts) as unknown as Promise<{ data: PermitLetter[]; meta?: any }>,
    []
  );
  return useResourceCollection<PermitLetter>(fetchFn, options);
}

export function useCreatePermitLetter(
  onSuccess?: (data: PermitLetter) => void
): MutationState<PermitLetter> {
  const createFn = useCallback(
    (data: any) => permitLettersService.create(data) as unknown as Promise<PermitLetter>,
    []
  );
  return useCreateResource<PermitLetter>(createFn, onSuccess);
}

export function useUpdatePermitLetter(
  onSuccess?: (data: PermitLetter) => void
): MutationState<PermitLetter> {
  const updateFn = useCallback(
    (id: string | number, data: any) => {
      const numericId = typeof id === 'string' ? parseInt(id, 10) : id;
      return permitLettersService.update(numericId, data) as unknown as Promise<PermitLetter>;
    },
    []
  );
  return useUpdateResource<PermitLetter>(updateFn, onSuccess);
}

export function useDeletePermitLetter(onSuccess?: () => void): MutationState<void> {
  const deleteFn = useCallback(
    (data: any) => {
      const documentId = data.documentId || data.id?.toString() || data.id;
      return permitLettersService.delete(documentId) as unknown as Promise<void>;
    },
    []
  );
  return useDeleteResource(deleteFn, onSuccess);
}
